import React, { useMemo, forwardRef } from 'react';
import clsx from 'clsx';
import { Element } from '../../atoms';
import { FieldContext } from './context';
import * as styles from './field.styles';

/** @type {typeof import(".").Field} */
const Field = forwardRef(({ className, children, status = 'default', disabled, name, onChange, value, ...props }, ref) => {
  const contextValue = useMemo(() => {
    return { status, disabled, name, onChange, value };
  }, [status, disabled, name, onChange, value]);

  return (
    <FieldContext.Provider value={contextValue}>
      <Element ref={ref} as="div" className={clsx(styles.field, className)} {...props}>
        {children}
      </Element>
    </FieldContext.Provider>
  );
});

if (process.env.NODE_ENV !== 'production') {
  Field.displayName = 'Field';
}

export default Field;
